<div class="d-flex flex-column justify-content-center align-items-center">
  <h3 style="color: #004F71">Add Components</h3>
  <form [formGroup]="form" class="component-form">

    <mat-form-field class="chips-autocomplete" appearance="outline">
      <mat-label>Choose components</mat-label>

      <mat-chip-grid #chipGrid aria-label="Selected options">
          @for (component of selectedComponents; track component) {
            <mat-chip-row removable="true" (removed)="remove(component)">
                {{ component }}
                <button matChipRemove matTooltip="Remove {{ component }}">
                    <mat-icon>cancel</mat-icon>
                </button>
            </mat-chip-row>
          }

          <input
              #componentInput
              matInput
              placeholder="Add components"
              [formControlName]="'newComponent'"
              [matAutocomplete]="auto"
              [matChipInputFor]="chipGrid"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputAddOnBlur]="false"
              (matChipInputTokenEnd)="add($event)"
              (paste)="onPaste($event)" />
      </mat-chip-grid>

      @if (form.get('newComponent')?.hasError('required')) {
        <mat-error>Component tag is required</mat-error>
      }
      @if (form.get('newComponent')?.hasError('duplicateComponent')) {
        <mat-error>Component tag(s) already exist: {{ form.get('newComponent')?.errors?.['duplicateComponent']?.value }}</mat-error>
      }

      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
          @for (component of filteredComponents | async; track component) {
            <mat-option [value]="component">{{ component }}</mat-option>
          }
          @if ((filteredComponents | async)?.length === 0) {
            <mat-option disabled>No matching options</mat-option>
          }
      </mat-autocomplete>
    </mat-form-field>
    @if (rejectedPasteTags.length > 0) {
      <p class="rejected-tags-message">
          <strong>The following tags were not added because they are not valid components:
        {{ rejectedPasteTags.join(', ') }}</strong>
      </p>
    }

  </form>
  <div mat-dialog-actions class="buttons-offset">
    <button mat-raised-button class="button-text-color" (click)="close()">Cancel</button>
    <button mat-raised-button class="button-text-color" (click)="save()" [disabled]="form?.invalid || (form?.pristine && selectedComponents?.length === 0)">
      <mat-icon aria-hidden="true" class="button-text-color">save</mat-icon>
      Save
    </button>
  </div>
</div>
